export default "__VITE_ASSET__06dc1339__"